const origin_url = 'https://menastockinstore.com';//window.location.origin;
module.exports = global.config = {
    i18n: {
        welcome: {
            en: "Welcome",
            fa: "خوش آمدید"
        }, 
    },
    live_url: origin_url,//"http://localhost:8000", //here you need to chnge as per api   
};